import { doNothing } from "@edgetier/utilities";
import { createContext } from "react";
import { IMobileNavigationContext } from "./mobile-navigation.context.types";

export const defaultContext = {
    closeMenu: doNothing,
    isMenuOpen: false,
};

export const MobileNavigationContext = createContext<IMobileNavigationContext>(defaultContext);
